import { useLocation } from 'react-router-dom'

/**
 * Where a broadcast page was opened FROM, when that was not the library.
 *
 * Carried in router location state rather than the URL: it is a breadcrumb,
 * not part of what the page shows, and a shared link should land with the
 * ordinary back button. The sponsor page sets it; the broadcast pages read it
 * for their back button and pass it along when they navigate to each other,
 * so switching tabs or opening a brand does not lose the way back.
 */
export interface BroadcastOrigin {
  path: string
  label: string
}

export interface OriginState {
  origin?: BroadcastOrigin
}

export const useBroadcastOrigin = (): { origin: BroadcastOrigin | null; state: OriginState | undefined } => {
  const state = useLocation().state as OriginState | null | undefined
  const origin = state?.origin ?? null
  return { origin, state: origin ? { origin } : undefined }
}
